import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css"; // Importa o CSS do Bootstrap
import { right } from "@popperjs/core";

export const ProjetosComponent = () => {
  const [dataEmpresa, setDataEmpresa] = useState(
    localStorage.getItem("dataEmpresa") || ""
  );

  // Estados para Empresas
  const [nomeEmpresa, setNomeEmpresa] = useState("");
  const [cnpjEmpresa, setCNPJEmpresa] = useState("");
  const [empresasCadastradas, setEmpresasCadastradas] = useState([]);
  const [showModalEmpresa, setShowModalEmpresa] = useState(false);
  const [empresaSelecionada, setEmpresaSelecionada] = useState<any>(null);

  // Estados para Centros de Custo
  const [nomeCentroCusto, setNomeCentroCusto] = useState("");
  const [codigoCentroCusto, setCodigoCentroCusto] = useState("");
  const [centroCustosCadastrados, setCentroCustosCadastrados] = useState([]);
  const [showModalCentroCusto, setShowModalCentroCusto] = useState(false);
  const [projetosCadastrados, setProjetosCadastrados] = useState([]);
  const [tipoDespesaEmpresa, setTipoDespesaEmpresa] = useState("")
  const [centroCustoSelecionado, setCentroCustoSelecionado] =
    useState<any>(null);
  const [empresaSelecionadaCentroCusto, setEmpresaSelecionadaCentroCusto] =
    useState("");

  // Fetch Empresas
  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getempresas/`
        );
        setEmpresasCadastradas(response.data);
      } catch (error) {
        console.error("Erro ao buscar empresas cadastradas:", error);
      }
    };

    fetchEmpresas();
  }, []);

  // Fetch Centros de Custo
  useEffect(() => {
    const fetchCentroCustos = async () => {
      try {
        const response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getcentrocusto/`
        );
        setCentroCustosCadastrados(response.data);
      } catch (error) {
        console.error("Erro ao buscar centros de custo cadastrados:", error);
      }
    };

    fetchCentroCustos();
  }, []);

  useEffect(() => {
    const fetchProjetos = async () => {
      try {
        const response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getprojetos/`
        );
        setProjetosCadastrados(response.data);
      } catch (error) {
        console.error("Erro ao buscar centros de custo cadastrados:", error);
      }
    };

    fetchProjetos();
  }, []);

  // Handlers para Empresas
  const handleSaveEmpresa = async () => {
    try {
      await axios.post(`https://financeiro.api.protmar.com.br/${dataEmpresa}/postempresas`, {
        nomeempresa: nomeEmpresa,
        cnpjempresa: cnpjEmpresa,
        tipodespesaempresa: tipoDespesaEmpresa
      });
      alert("Empresa cadastrada com sucesso!");
      window.location.reload();
    } catch (error) {
      console.error("Erro ao cadastrar empresa:", error);
      alert("Erro ao cadastrar empresa");
    }
  };

  const handleEditEmpresa = (empresa: any) => {
    setEmpresaSelecionada(empresa);
    setNomeEmpresa(empresa.nomeempresa);
    setCNPJEmpresa(empresa.cnpjempresa);
    setShowModalEmpresa(true);
  };

  const handleModalCloseEmpresa = () => {
    setShowModalEmpresa(false);
    setEmpresaSelecionada(null);
    setNomeEmpresa("");
    setCNPJEmpresa("");
  };

  const handleModalSaveEmpresa = async () => {
    try {
      if (empresaSelecionada) {
        await axios.put(`https://financeiro.api.protmar.com.br/${dataEmpresa}/putempresas`, {
          nomeempresa: nomeEmpresa,
          cnpjempresa: cnpjEmpresa,
          id: empresaSelecionada.id,
        });
      }
      alert("Empresa editada com sucesso!");
      setShowModalEmpresa(false);
      window.location.reload();
    } catch (error) {
      console.error("Erro ao editar empresa:", error);
      alert("Erro ao editar empresa");
    }
  };

  // Handlers para Centros de Custo
  const handleSaveCentroCusto = async () => {
    try {
      await axios.post(`https://financeiro.api.protmar.com.br/${dataEmpresa}/postcentrocusto`, {
        nomecentrocusto: nomeCentroCusto,
        idempresa: empresaSelecionadaCentroCusto,
      });
      alert("Centro de Custo cadastrado com sucesso!");
      window.location.reload();
    } catch (error) {
      console.error("Erro ao cadastrar centro de custo:", error);
      alert("Erro ao cadastrar centro de custo");
    }
  };

  const handleEditCentroCusto = (centroCusto: any) => {
    setCentroCustoSelecionado(centroCusto);
    setNomeCentroCusto(centroCusto.nomecentrocusto);
    setCodigoCentroCusto(centroCusto.codigocentrocusto);
    setShowModalCentroCusto(true);
  };

  const handleModalCloseCentroCusto = () => {
    setShowModalCentroCusto(false);
    setCentroCustoSelecionado(null);
    setNomeCentroCusto("");
    setCodigoCentroCusto("");
  };

  const handleModalSaveCentroCusto = async () => {
    try {
      if (centroCustoSelecionado) {
        await axios.put(`https://financeiro.api.protmar.com.br/${dataEmpresa}/putcentrocusto`, {
          nomecentrocusto: nomeCentroCusto,
          idempresa: empresaSelecionadaCentroCusto,
          id: centroCustoSelecionado.id,
        });
      }
      alert("Centro de Custo editado com sucesso!");
      setShowModalCentroCusto(false);
      window.location.reload();
    } catch (error) {
      console.error("Erro ao editar centro de custo:", error);
      alert("Erro ao editar centro de custo");
    }
  };

  // Estados para Projetos
  const [nomeProjeto, setNomeProjeto] = useState("");
  const [idCentroCustoSelecionado, setIdCentroCustoSelecionado] = useState("");
  const [showModalProjeto, setShowModalProjeto] = useState(false);
  const [projetoSelecionado, setProjetoSelecionado] = useState<any>(null);

  // Função para salvar um novo projeto
  const handleSaveProjeto = async () => {
    try {
      await axios.post(`https://financeiro.api.protmar.com.br/${dataEmpresa}/postprojetos`, {
        nomeprojeto: nomeProjeto,
        idcentrocusto: idCentroCustoSelecionado,
      });
      alert("Projeto cadastrado com sucesso!");
      window.location.reload();
    } catch (error) {
      console.error("Erro ao cadastrar projeto:", error);
      alert("Erro ao cadastrar projeto");
    }
  };

  // Função para preparar a edição de um projeto
  const handleEditProjeto = (projeto: any) => {
    setProjetoSelecionado(projeto);
    setNomeProjeto(projeto.nomeprojeto);
    setIdCentroCustoSelecionado(projeto.idcentrocusto);
    setShowModalProjeto(true);
  };

  // Função para fechar o modal de edição
  const handleModalCloseProjeto = () => {
    setShowModalProjeto(false);
    setProjetoSelecionado(null);
    setNomeProjeto("");
    setIdCentroCustoSelecionado("");
  };

  // Função para salvar as alterações do projeto
  const handleModalSaveProjeto = async () => {
    if (!nomeProjeto || !idCentroCustoSelecionado) {
      alert("Por favor, preencha todos os campos.");
      return;
    }

    try {
      if (projetoSelecionado) {
        await axios.put(`https://financeiro.api.protmar.com.br/${dataEmpresa}/putprojetos`, {
          id: projetoSelecionado.id,
          nomeprojeto: nomeProjeto,
          idcentrocusto: idCentroCustoSelecionado,
        });
        alert("Projeto atualizado com sucesso!");
        // Atualiza a lista de projetos
        const response = await axios.get(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/getprojetos/`
        );
        setProjetosCadastrados(response.data);
        // Fecha o modal e limpa os estados
        handleModalCloseProjeto();
      }
    } catch (error) {
      console.error("Erro ao atualizar projeto:", error);
      alert("Erro ao atualizar projeto");
    }
  };

  return (
    <section style={{ width: "98%", position: "absolute", top: "80px" }}>
      {/* Seção de Empresas */}
      <h4>Registrar Empresa</h4>
      <form>
        <div>
          <input
            className="form-control"
            type="text"
            placeholder="Nome da Empresa"
            aria-label="Nome da Empresa"
            value={nomeEmpresa}
            onChange={(e: any) => setNomeEmpresa(e.target.value)}
          />
          <br />
          <div style={{ display: "flex" }}>
            <input
              className="form-control"
              type="text"
              placeholder="CNPJ da Empresa"
              aria-label="CNPJ da Empresa"
              style={{ marginRight: "10px" }}
              value={cnpjEmpresa}
              onChange={(e: any) => setCNPJEmpresa(e.target.value)}
            />

            <button
              onClick={handleSaveEmpresa}
              className="btn btn-primary"
              type="button"
            >
              Salvar
            </button>
          </div>
        </div>
      </form>
      
      <br />

      <h5>Empresas Cadastradas</h5>
      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
        <table className="table table-striped">
          <tbody>
            {empresasCadastradas.map((e: any) => (
              <tr key={e.id}>
                <td>{e.nomeempresa}</td>
                <td style={{ position: "relative" }}>
                  <button
                    onClick={() => handleEditEmpresa(e)}
                    className="btn btn-sm btn-secondary"
                    style={{position: "absolute", right: "10px", bottom: "4px"}}
                  >
                    Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <br />
      

      {/* Modal para Empresas */}
      {showModalEmpresa && (
        <div className="modal show d-block" tabIndex={-1}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Editar Empresa</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalCloseEmpresa}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  type="text"
                  placeholder="Nome da Empresa"
                  value={nomeEmpresa}
                  onChange={(e: any) => setNomeEmpresa(e.target.value)}
                />
                <input
                  className="form-control"
                  type="text"
                  placeholder="CNPJ da Empresa"
                  value={cnpjEmpresa}
                  onChange={(e: any) => setCNPJEmpresa(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleModalCloseEmpresa}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={async () => {
                    try {
                      
                      await axios.delete(
                        `https://financeiro.api.protmar.com.br/${dataEmpresa}/deleteempresas/${empresaSelecionada.id}`
                      );
                      alert("Empresa deletada com sucesso!");
                      // Atualiza a lista de empresas
                      const response = await axios.get(
                        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getempresas/`
                      );
                      setEmpresasCadastradas(response.data);
                      // Fecha o modal e limpa os estados
                      handleModalCloseEmpresa();


                    } catch (error) {
                      
                    }
                  }}
                >
                  Deletar
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleModalSaveEmpresa}
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <hr />

      {/* Seção de Centros de Custo */}
      <h4>Registrar Centro de Custo</h4>
      <form>
        <div>
          <input
            className="form-control"
            type="text"
            placeholder="Nome do Centro de Custo"
            aria-label="Nome do Centro de Custo"
            value={nomeCentroCusto}
            onChange={(e: any) => setNomeCentroCusto(e.target.value)}
          />
          <br />
          <div style={{ display: "flex" }}>
            <select
              className="form-select"
              aria-label="Selecione a Empresa"
              style={{ marginRight: "10px" }}
              value={empresaSelecionadaCentroCusto}
              onChange={(e: any) =>
                setEmpresaSelecionadaCentroCusto(e.target.value)
              }
            >
              <option value="">Selecione a Empresa</option>
              {empresasCadastradas.map((empresa: any) => (
                <option key={empresa.id} value={empresa.nomeempresa}>
                  {empresa.nomeempresa}
                </option>
              ))}
            </select>

            <button
              onClick={handleSaveCentroCusto}
              className="btn btn-primary"
              type="button"
            >
              Salvar
            </button>
          </div>
        </div>
      </form>
      
      <br />
      
      <h5>Centros de Custo Cadastrados</h5>
      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
        <table className="table table-striped">
          <tbody>
            {centroCustosCadastrados.map((cc: any) => (
              <tr key={cc.id}>
                <td>{cc.nomecentrocusto}</td>
                <td>{cc.codigocentrocusto}</td>
                <td style={{ position: "relative" }}>
                  <button
                    onClick={() => handleEditCentroCusto(cc)}
                    className="btn btn-sm btn-secondary"
                    style={{position: "absolute", right: "10px", bottom: "4px"}}
                  >
                    Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <br />
      

      {/* Modal para Centros de Custo */}
      {showModalCentroCusto && (
        <div className="modal show d-block" tabIndex={-1}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Editar Centro de Custo</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalCloseCentroCusto}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  type="text"
                  placeholder="Nome do Centro de Custo"
                  value={nomeCentroCusto}
                  onChange={(e: any) => setNomeCentroCusto(e.target.value)}
                />

                <select
                  className="form-select"
                  aria-label="Selecione a Empresa"
                  style={{ marginRight: "10px" }}
                  value={empresaSelecionadaCentroCusto}
                  onChange={(e: any) =>
                    setEmpresaSelecionadaCentroCusto(e.target.value)
                  }
                >
                  <option value="">Selecione a Empresa</option>
                  {empresasCadastradas.map((empresa: any) => (
                    <option key={empresa.id} value={empresa.nomeempresa}>
                      {empresa.nomeempresa}
                    </option>
                  ))}
                </select>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleModalCloseCentroCusto}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={async () => {
                    try {
                      
                      await axios.delete(
                        `https://financeiro.api.protmar.com.br/${dataEmpresa}/deletecentrocusto/${centroCustoSelecionado.id}`
                      );
                      alert("Empresa deletada com sucesso!");
                      // Atualiza a lista de empresas
                      const response = await axios.get(
                        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getcentrocusto/`
                      );
                      setCentroCustosCadastrados(response.data);
                      // Fecha o modal e limpa os estados
                      handleModalCloseEmpresa();


                    } catch (error) {
                      
                    }
                  }}
                >
                  Deletar
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleModalSaveCentroCusto}
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <hr />

      <h4>Registrar Projeto</h4>
      <form>
        <div>
          <input
            className="form-control"
            type="text"
            placeholder="Nome do Projeto"
            aria-label="Nome do Projeto"
            value={nomeProjeto}
            onChange={(e: any) => setNomeProjeto(e.target.value)}
          />
          <br />
          <div style={{ display: "flex" }}>
            <select
              className="form-select"
              aria-label="Selecione o Centro de Custo"
              style={{ marginRight: "10px" }}
              value={idCentroCustoSelecionado}
              onChange={(e: any) => setIdCentroCustoSelecionado(e.target.value)}
            >
              <option value="">Selecione o Centro de Custo</option>
              {centroCustosCadastrados.map((cc: any) => (
                <option key={cc.id} value={cc.nomecentrocusto}>
                  {cc.nomecentrocusto}
                </option>
              ))}
            </select>

            <button
              onClick={handleSaveProjeto}
              className="btn btn-primary"
              type="button"
            >
              Salvar
            </button>
          </div>
        </div>
      </form>

      <br />

      {/* Seção de Projetos */}
      <h5>Projetos Cadastrados</h5>
      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
        <table className="table table-striped">
          <tbody>
            {projetosCadastrados.map((projeto: any) => (
              <tr key={projeto.id}>
                <td>{projeto.nomeprojeto}</td>
                <td style={{ position: "relative" }}>
                  <button
                    onClick={() => handleEditProjeto(projeto)}
                    className="btn btn-sm btn-secondary"
                    style={{position: "absolute", right: "10px", bottom: "4px"}}
                  >
                    Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <br />
      

      {/* Modal para Projetos */}
      {showModalProjeto && (
        <div className="modal show d-block" tabIndex={-1}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Editar Projeto</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalCloseProjeto}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  type="text"
                  placeholder="Nome do Projeto"
                  value={nomeProjeto}
                  onChange={(e: any) => setNomeProjeto(e.target.value)}
                />

                <select
                  className="form-select"
                  aria-label="Selecione o Centro de Custo"
                  value={idCentroCustoSelecionado}
                  onChange={(e: any) => setProjetoSelecionado(e.target.value)}
                >
                  <option value="">Selecione o Centro de Custo</option>
                  {centroCustosCadastrados.map((cc: any) => (
                    <option key={cc.id} value={cc.id}>
                      {cc.nomecentrocusto}
                    </option>
                  ))}
                </select>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleModalCloseProjeto}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={async () => {
                    try {
                      
                      await axios.delete(
                        `https://financeiro.api.protmar.com.br/${dataEmpresa}/deleteprojetos/${projetoSelecionado.id}`
                      );
                      alert("Empresa deletada com sucesso!");
                      // Atualiza a lista de empresas
                      const response = await axios.get(
                        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getprojetos/`
                      );
                      setProjetosCadastrados(response.data);
                      // Fecha o modal e limpa os estados
                      handleModalCloseEmpresa();


                    } catch (error) {
                      
                    }
                  }}
                >
                  Deletar
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleModalSaveProjeto}
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
